var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenceDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lizenz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,21V65H75V21ZM73,63H37V23H73Z",
    transform: "translate(-35 -21)",
    fill: "#b4ccdd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.06,
    y: 43.04,
    width: 29.87,
    height: 16.89,
    transform: "translate(75 81.97) rotate(180)",
    fill: "#b4ccdd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.24,
    y: 8.29,
    width: 23.53,
    height: 27.44,
    fill: "#05548e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.06,
    y: 26.2,
    width: 29.87,
    height: 16.84,
    transform: "translate(75 48.24) rotate(180)",
    fill: "#05548e"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 10.26,
    width: 19.57,
    height: 23.45,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 13.28,
    width: 14.5,
    height: 1.97,
    fill: "#05548e"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 18.11,
    width: 14.5,
    height: 1.97,
    fill: "#05548e"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 22.94,
    width: 14.5,
    height: 1.97,
    fill: "#05548e"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.75,
    y: 27.78,
    width: 14.5,
    height: 1.97,
    fill: "#05548e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.25,43.2A6.5,6.5,0,0,0,57.51,54V64.24l4.75-3.74,4.87,3.71V53.85a6.52,6.52,0,0,0,1.5-4.17A6.43,6.43,0,0,0,62.25,43.2Z",
    transform: "translate(-35 -21)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.78,50a4.53,4.53,0,1,0-9.05,0A4.78,4.78,0,0,0,59,53.29v7.38l3.23-2.6,3.33,2.6v-7.5A4.77,4.77,0,0,0,66.78,50Z",
    transform: "translate(-35 -21)",
    fill: "#05548e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceDefault);
export default __webpack_public_path__ + "static/media/licence-default.9c017d873f5c78450ddc7e257408ff41.svg";
export { ForwardRef as ReactComponent };